module.exports = __webpack_public_path__ + "img/Awaken-film-Comp-photo-2000px.19e1ce2.jpg";